import styled from 'styled-components';
import { colors } from '@/globalStyles';
import { styled as muiStyled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/AddSharp';

export const ColorSelectWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: ${props =>
    props.$colorsList?.length === 2 ? 'repeat(2, 1fr)' : 'repeat(8, 1fr)'};
  align-items: center;
  justify-content: space-between;

  .ColorItemRect, * .ColorItemRect {
    border-radius: 4px;
    width: 20px;
    height: 20px;

    &:hover {
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
        border: solid 1px #ffffff;
    }
  }
`;

export const ColorItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
  align-self: center;
  width: 26px;
  height: 26px;
  box-shadow: ${props =>
    props.$selected ? '0 2px 4px 0 rgba(0, 0, 0, 0.25)' : 'none'};
  border: ${props =>
    props.$selected ? 'solid 1px #ffffff' : 'solid 1px #ccd0d2'};
  background-color: ${props => (props.$color ? props.$color : '#000')};
  border-radius: 100%;
  cursor: pointer;

  &:hover {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    border: solid 3px #ffffff;
  }
`;

export const AddColorButton = styled.div`
  justify-self: center;
  align-self: center;
  width: 26px;
  height: 26px;
  border-radius: 100%;
  border: solid 1px ${colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const AddIconStyled = muiStyled(AddIcon)(() => ({
  fill: colors.primary,
  width: '90%',
  height: '90%',
  strokeWidth: '0',
}));

export const Icon = styled.img`
  width: 10px;
  height: 10px;
`;
